// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__LaNb4","header":"ClearentDisclaimer_header__1wIo3","inner":"ClearentDisclaimer_inner__31NID"};